const config = {
  // apiUrl: " http://localhost/INVENTORY BCK/inventorybe_bck/public/",
  // storageUrl: " http://localhost/INVENTORY BCK/inventorybe_bck/storage/",

  apiUrl: "https://inventorybe.bck.co.id/public/",
  storageUrl: "https://inventorybe.bck.co.id/storage/",
};

export default config;
